import { FunctionComponent, ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface InternalLinkProps {
    route: string;
    title?: string | null;
    className?: string;
    children: ReactNode;
}

const InternalLink: FunctionComponent<InternalLinkProps> = ({
    route,
    title,
    className,
    children,
}) => (
    <Link to={route} {...(title ? { title } : {})} className={className}>
        {children}
    </Link>
);

export default InternalLink;
